import { PropsWithChildren, ReactNode } from 'react';
import { Tooltip } from '@mui/material';
import classNames from 'classnames';

import styles from './Chip.module.scss';

export interface ChipProps extends PropsWithChildren {
    color?: 'default' | 'primary' | 'secondary' | 'positive' | 'danger';
    customColor?: string;
    customTextColor?: string;
    startIcon?: ReactNode;
    tooltip?: string;
    onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export const Chip = ({
    color,
    customColor,
    customTextColor,
    startIcon,
    tooltip,
    onClick,
    children,
}: ChipProps) => {
    const customStyle =
        customColor || customTextColor
            ? ({
                  ...(customColor && { '--chip-background': customColor }),
                  ...(customTextColor && { '--chip-text': customTextColor }),
              } as React.CSSProperties)
            : undefined;

    const chipContent = (
        <span
            className={classNames(
                styles.container,
                !(customColor || customTextColor) && styles[color ?? 'default'],
                onClick && styles.clickable,
            )}
            style={customStyle}
            onClick={onClick}
        >
            {startIcon && <span className={styles.startIcon}>{startIcon}</span>}
            {children}
        </span>
    );

    if (tooltip) {
        return (
            <Tooltip title={tooltip} arrow placement="top">
                {chipContent}
            </Tooltip>
        );
    }

    return chipContent;
};
